import { render, staticRenderFns } from "./TsTravelB.vue?vue&type=template&id=8336a9aa&scoped=true"
import script from "./TsTravelB.vue?vue&type=script&lang=js"
export * from "./TsTravelB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8336a9aa",
  null
  
)

export default component.exports